import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Alert from '../../../../../Alert';

import ServicerService from '../../../../../../services/ServicerService';
import createServicerBankAccountsOptions from '../../../../../../helpers/forms/createServicerBankAccountsOptions';

const createWarningMessage = (loan, paymentValues, servicerBankAccounts) => {
  const isServicerPayer = paymentValues?.payer === 'Servicer';
  const isLenderPayer = paymentValues?.payer === 'Lender';

  if (loan?.ach_type === 'off') {
    return 'This loan is not setup for ACH payments. By selecting ACH as the source for this payment, a payment will be created, but not initiated until the loan is setup for ACH.';
  }

  if (!isServicerPayer && !isLenderPayer && loan?.ach_type !== 'off') {
    return `This loan is setup for ACH payments. By selecting ACH as the source for this payment, the borrower's bank account will be drafted the payment amount.`;
  }

  if (isServicerPayer && loan?.ach_type !== 'off') {
    const options = createServicerBankAccountsOptions(servicerBankAccounts);

    let bankAccountType = 'bank';

    if (paymentValues?.bank_account_id) {
      const selectedBankAccount = options?.find(
        (account) => account.id === paymentValues?.bank_account_id
      );

      console.log('servicerBankAccounts', servicerBankAccounts);

      if (selectedBankAccount) {
        bankAccountType = selectedBankAccount?.option;
      }
    }

    return `This loan is setup for ACH payments. By selecting ACH as the source for this payment, the servicer's ${bankAccountType} account will be drafted the payment amount.`;
  }

  if (isLenderPayer && loan?.ach_type !== 'off') {
    return `This loan is setup for ACH payments. By selecting ACH as the source for this payment, the lender's bank account will be drafted the payment amount.`;
  }

  return '';
};

export default function AchAlert({ loan, paymentValues }) {
  const isServicerPayer = paymentValues?.payer === 'Servicer';

  const { data: servicerBankAccounts } = useQuery({
    queryKey: ['servicerBankAccounts'],
    queryFn: ServicerService.getServicerBankAccounts,
    enabled: isServicerPayer,
  });

  const message = createWarningMessage(
    loan,
    paymentValues,
    servicerBankAccounts
  );

  if (paymentValues?.source !== 'ACH' || !paymentValues?.payer) {
    return null;
  }

  return (
    <div className="mt-5 -mb-10">
      <Alert message={message} />
    </div>
  );
}
